export const renderTree = (data, parent = null) => {
  const tree = []
  for (let i = 0; i < data.length; i++) {
    const prev = i !== 0 ? data[i - 1] : null
    const item = data[i]
    const next = i !== data.length - 1 ? data[i + 1] : null
    if (item.subList && item.subList.length > 0) {
      item.children = renderTree(item.subList, item)
    }
    const len = item.ancestors.split(',')?.length
    const node = {
      id: item.id,
      pid: item.pid,
      prev: prev?.id,
      label: item.name,
      parent,
      sort: item.sort,
      next: next?.id,
      level: len,
      children: item.children,
    }

    tree.push(node)
  }
  return tree
}

